import { useLayoutEffect } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks';

/** 전체보기(전체메뉴) 화면 진입 시 VIEW_OVERVIEW_ICON_ALL 발화. */
export const useLogViewServiceMap = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  useLayoutEffect(() => {
    logAnalyticsEvent({
      name: 'VIEW_OVERVIEW_ICON_ALL',
    });
  }, [logAnalyticsEvent]);
};
